import React from 'react';
import clsx from 'clsx';

// Material
import Grid from '@material-ui/core/Grid'
// Loader components
import ProductListItemLoader from './../ProductListItem/ProductListItem.loader'
// Styles
import useStyles from './CategoryItem.style.js'

const CategoryItemLoader = () => {
    const classes = useStyles();
    return (<div className={classes.root}>
        <div className={clsx('heading__loading')}></div>
        <div className={clsx('sub-heading-1__loading')}></div>
        <Grid container spacing={2}>
            <Grid item xs={12} sm={6} key={1}>
                <ProductListItemLoader />
            </Grid>
            <Grid item xs={12} sm={6} key={2}>
                <ProductListItemLoader />
            </Grid>
        </Grid>
    </div>)
};

export default CategoryItemLoader;